"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingIndicator = void 0;

var icons_1 = require("@ant-design/icons");

var web_1 = require("@thesisedu/web");

var react_1 = __importDefault(require("react"));

function LoadingIndicator(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '@size-s' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '@gray-6' : _ref$color,
      block = _ref.block;
  var theme = react_1.default.useContext(web_1.StyledThemeContext);
  if (block) return react_1.default.createElement(web_1.BlockSpin, null);
  return react_1.default.createElement(icons_1.LoadingOutlined, {
    style: {
      color: theme[color] ? theme[color] : color,
      fontSize: parseFloat(theme[size].replace('px', ''))
    }
  });
}

exports.LoadingIndicator = LoadingIndicator;